module.exports = __webpack_public_path__ + "static/media/disclaimer-blue.4b8c3a55.svg";